import { render, staticRenderFns } from "./NotAuthorize.vue?vue&type=template&id=68237c00"
import script from "./NotAuthorize.vue?vue&type=script&lang=js"
export * from "./NotAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports